const BASIC = "basic";
const STANDARD = "standard";
const PRO = "pro";
const CREDITS_PER_SEAT_PER_TIER = {
    [BASIC]: 600,
    [STANDARD]: 800,
    [PRO]: 1000
};
const getCreditsPerSeatAmount = (tierName)=>{
    var _CREDITS_PER_SEAT_PER_TIER_tierName;
    return (_CREDITS_PER_SEAT_PER_TIER_tierName = CREDITS_PER_SEAT_PER_TIER[tierName]) !== null && _CREDITS_PER_SEAT_PER_TIER_tierName !== void 0 ? _CREDITS_PER_SEAT_PER_TIER_tierName : null;
};
// Shared account pool: credits contributed per seat (total = value × seats).
// `null` = row shown but unavailable ("--"); missing tier = no row (e.g. Enterprise).
const SHARED_CREDITS_POOL_PER_SEAT = {
    [BASIC]: null,
    [STANDARD]: null,
    [PRO]: 200
};
const shouldShowSharedCreditsPoolRow = (tierName)=>Object.prototype.hasOwnProperty.call(SHARED_CREDITS_POOL_PER_SEAT, tierName);
const getSharedCreditsPoolAmount = (tierName, seats)=>{
    if (!shouldShowSharedCreditsPoolRow(tierName)) return undefined;
    const creditsPerSeat = SHARED_CREDITS_POOL_PER_SEAT[tierName];
    if (creditsPerSeat == null) return null;
    return creditsPerSeat * seats;
};
module.exports = {
    CREDITS_PER_SEAT_PER_TIER,
    SHARED_CREDITS_POOL_PER_SEAT,
    getCreditsPerSeatAmount,
    getSharedCreditsPoolAmount,
    shouldShowSharedCreditsPoolRow
};
